import React, { ReactElement, ReactNode } from 'react';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import { IntlShape, useIntl } from 'react-intl';
import { getDefaultWorkRelatedIdentifierInternal } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { getVocabularyOptions } from '../../../../Vocabulary/util';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { InputGroup } from '../layout/InputGroup';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { Panel } from '../layout/Panel';
import { InputText } from 'primereact/inputtext';
import { ReferencedWorkDTO, WorkRelatedIdentifierInternalDTO } from '../../../../api/core';
import { LabelledWorkSuggester } from '../../../components/form/LabelledWorkSuggester';

interface WorkReferencedIdentifierInternalProps {
  title: string;
  identifiers: WorkRelatedIdentifierInternalDTO[];
  onChange: (subject: WorkRelatedIdentifierInternalDTO[]) => void;
  pubtypeGroup: string;
  validation: ValidationResult;
  checkPermission: CheckPermissionFunction;
  autoFocus: boolean;
}

export function WorkReferencedIdentifierInternal(props: WorkReferencedIdentifierInternalProps): ReactNode {
  const intl: IntlShape = useIntl();
  return (
    <Panel title={props.title} toggleable={true}>
      <MultiInputControls<WorkRelatedIdentifierInternalDTO>
        canEdit={props.checkPermission().canWrite}
        lines={props.identifiers || []}
        onChange={props.onChange}
        addNew={(rows: WorkRelatedIdentifierInternalDTO[]): number => rows.push(getDefaultWorkRelatedIdentifierInternal())}
        renderLines={(identifier: WorkRelatedIdentifierInternalDTO, onLineChange: (workRelatedIdentifierInternalDTO: WorkRelatedIdentifierInternalDTO) => void, actions: Actions, idx: number): ReactElement => (
          <InputGroup
            delete={{
              action: actions.delete,
              disabled: !props.checkPermission().canWrite,
            }}
          >
            <InputText
              id={`internalRelation-${idx}-source`}
              value={intl.formatMessage({id: `${props.title}.attr.thisWork`})}
              disabled={true}
              className={'w-full flex-1 min-w-0'}
            />
            <LabelledDropdown
              id={`internalRelation-${idx}-type`}
              autoFocus={props.autoFocus}
              value={identifier.relationType}
              className={'w-full'}
              wrapperClassName={'flex-1 min-w-0'}
              permissions={props.checkPermission('relation_type')}
              validation={props.validation?.children[idx]?.fields?.relation_type}
              onChange={(relationType: string): void => onLineChange({...identifier, relationType})}
              options={getVocabularyOptions(intl.locale, 'relation_type_list', props.pubtypeGroup)}
              label={`${props.title}.attr.type`}

            />
            <LabelledWorkSuggester
              id={`internalRelation-${idx}-target`}
              wrapperClassName={'flex-1 min-w-0'}
              value={identifier.referencedWork ? [identifier.referencedWork] : []}
              multiple={false}
              permissions={props.checkPermission('referenced_work')}
              validation={props.validation?.children[idx]?.fields?.referenced_work}
              onChange={(ref: ReferencedWorkDTO[]): void => onLineChange({
                ...identifier,
                referencedWork: ref.length > 0 ? ref.pop() : undefined,
              })}
              label={`${props.title}.attr.referencedWork`}/>
          </InputGroup>
        )}
      />
    </Panel>
  );
}
